// extracted by mini-css-extract-plugin
export var alternate = "_19-j";
export var black = "_19-6";
export var blue = "_19-f";
export var blueLight = "_19-e";
export var brand = "_19-8";
export var darkMode = "_19-b";
export var error = "_19-a";
export var gray = "_19-5";
export var grayBlue = "_19-d";
export var iconWrapper = "_19-3";
export var inactive = "_19-7";
export var indigo = "_19-g";
export var orange = "_19-i";
export var pink = "_19-h";
export var primary = "_19-0";
export var purple = "_19-9";
export var success = "_19-4";
export var warning = "_19-c";
export var white = "_19-1";
export var whiteSuccess = "_19-2";